'use client';

import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import ShowToast from "../../utils/ShowToast";
import CartContext from "../../Context/Cart/CartContext";
import FormatCurrency from "../../utils/FormatCurrency";
import AuthContext from "../../Context/auth/AuthContext";

const CardProduct = ({ product, slider }) => {
  const miImagen = require("../../assets/img/default .png");
  const { autenticado } = useContext(AuthContext);
  const { name, img, id, price, stock } = product;
  const { agregarProducto, cart } = useContext(CartContext);
  const [isHovered, setIsHovered] = useState(false);

  const agregarProductsState = (prod) => {
    Swal.fire({
      title: '<span style="font-weight: 800; font-size: 1.25rem; color: #111;">Agregar al carrito</span>',
      html: `
        <div style="text-align: left; padding: 0 10px;">
          <p style="color: #666; margin-bottom: 16px; font-size: 0.9rem;">${name}</p>
          <label style="font-size: 0.8rem; font-weight: 700; color: #111; text-transform: uppercase; letter-spacing: 0.5px;">
            Cantidad
          </label>
          <input 
            type="number" 
            id="quantity" 
            value="1"
            min="1"
            max="${stock}"
            style="
              width: 100%;
              padding: 14px 16px;
              border: 2px solid #e5e5e5;
              border-radius: 8px;
              font-size: 1rem;
              font-weight: 600;
              margin-top: 8px;
              transition: border-color 0.2s;
              outline: none;
            "
            onfocus="this.style.borderColor='#111'"
            onblur="this.style.borderColor='#e5e5e5'"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
          >
          <p style="color: #888; font-size: 0.8rem; margin-top: 8px;">
            ${stock} disponibles
          </p>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Agregar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      customClass: {
        popup: 'nike-popup',
        confirmButton: 'nike-confirm-btn',
        cancelButton: 'nike-cancel-btn',
      },
      buttonsStyling: false,
      didOpen: () => {
        // Custom button styles
        const style = document.createElement('style');
        style.textContent = `
          .nike-popup {
            border-radius: 16px !important;
            padding: 24px !important;
          }
          .nike-confirm-btn {
            background: #111 !important;
            color: #fff !important;
            padding: 14px 28px !important;
            border-radius: 30px !important;
            font-weight: 600 !important;
            font-size: 0.95rem !important;
            border: none !important;
            cursor: pointer !important;
            transition: all 0.2s !important;
          }
          .nike-confirm-btn:hover {
            background: #333 !important;
            transform: scale(1.02) !important;
          }
          .nike-cancel-btn {
            background: transparent !important;
            color: #666 !important;
            padding: 14px 28px !important;
            border-radius: 30px !important;
            font-weight: 600 !important;
            font-size: 0.95rem !important;
            border: 1.5px solid #ddd !important;
            cursor: pointer !important;
            transition: all 0.2s !important;
            margin-right: 8px !important;
          }
          .nike-cancel-btn:hover {
            border-color: #111 !important;
            color: #111 !important;
          }
        `;
        document.head.appendChild(style);
      },
      preConfirm: () => {
        const quantity = parseInt(
          Swal.getPopup().querySelector("#quantity").value,
          10
        );
        if (!quantity || quantity <= 0) {
          Swal.showValidationMessage("La cantidad debe ser mayor a 0");
          return false;
        } else if (quantity > stock) {
          Swal.showValidationMessage(
            `Máximo ${stock} unidades disponibles`
          );
          return false;
        }
        return { quantity };
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const quantityToAdd = result.value.quantity;
        agregarProducto(prod, quantityToAdd);

        // Nike-style success toast
        Swal.fire({
          toast: true,
          position: 'bottom-end',
          icon: 'success',
          title: `<span style="font-weight: 600;">${quantityToAdd} ${quantityToAdd > 1 ? 'productos agregados' : 'producto agregado'}</span>`,
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true,
          customClass: {
            popup: 'nike-toast'
          },
          didOpen: () => {
            const style = document.createElement('style');
            style.textContent = `
              .nike-toast {
                background: #111 !important;
                color: #fff !important;
                border-radius: 8px !important;
                padding: 12px 20px !important;
              }
              .nike-toast .swal2-icon.swal2-success {
                border-color: #fff !important;
              }
              .nike-toast .swal2-icon.swal2-success [class^=swal2-success-line] {
                background-color: #fff !important;
              }
            `;
            document.head.appendChild(style);
          }
        });
      }
    });
  };

  const copiarEnlace = () => {
    const enlace = `Mira este producto! ${name} Encuentralo aqui: https://distribucion.merrycolor.mx/product/${id}`;
    navigator.clipboard.writeText(enlace).then(() => {
      ShowToast(
        "success",
        "Enlace copiado",
        "Compartelo en WhatsApp o Facebook!"
      );
    });
  };

  const productoEnCarrito = cart.some((item) => item.product_id === product.id);
  const productImage = img.length > 0 ? img[0]?.image : miImagen;

  return (
    <div
      className="group relative w-full bg-white transition-all duration-300"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Image Container */}
      <Link
        to={autenticado ? `/producto/${id}` : `/product/${id}`}
        className="relative block aspect-square w-full overflow-hidden rounded-lg bg-[#f5f5f5]"
      >
        <img
          src={productImage}
          alt={name}
          className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-105"
        />

        {/* Discount Badge */}
        {product?.price_with_discount > 0 && (
          <span className="absolute top-3 left-3 rounded-full bg-[#d44f4f] px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-white">
            Oferta
          </span>
        )}

        {/* Quick Add Button - Nike Style */}
        {stock >= 1 && (
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              agregarProductsState(product);
            }}
            className={`absolute bottom-3 right-3 flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-lg transition-all duration-300 hover:scale-110 ${isHovered ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
              }`}
          >
            <svg className="h-5 w-5 text-[#111]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
            </svg>
          </button>
        )}
      </Link>

      {/* Product Info */}
      <div className="pt-3 pb-1">
        {/* Category/Status */}
        <div className="flex items-center justify-between mb-1">
          <span
            className={`text-[11px] font-semibold uppercase tracking-wide ${productoEnCarrito ? 'text-[#008000]' : stock < 10 ? 'text-[#d44f4f]' : 'text-[#707072]'
              }`}
          >
            {productoEnCarrito ? 'En carrito' : stock < 10 ? `Solo ${stock} disponibles` : `${stock} Disponibles`}
          </span>
        </div>

        {/* Name */}
        <Link to={autenticado ? `/producto/${id}` : `/product/${id}`}>
          <h3 className="text-[15px] font-medium leading-tight text-[#111] line-clamp-2 hover:text-[#707072] transition-colors">
            {name}
          </h3>
        </Link>

        {/* Price */}
        <div className="mt-2 flex items-center gap-2">
          <span className="text-[15px] font-semibold text-[#111]">
            {product?.price_with_discount
              ? FormatCurrency(product.price_with_discount)
              : FormatCurrency(product.price)}
          </span>
          {product.price_with_discount > 0 && (
            <span className="text-[13px] text-[#707072] line-through">
              {FormatCurrency(product.price)}
            </span>
          )}
        </div>

        {/* Action Buttons - Mobile Only */}
        <div className="flex items-center gap-2 mt-3 md:hidden">
          {stock >= 1 && (
            <button
              onClick={() => agregarProductsState(product)}
              className={`flex-1 rounded-full py-2.5 text-sm font-semibold transition-all duration-200 ${productoEnCarrito
                ? 'bg-[#111] text-white'
                : 'bg-[#f5f5f5] text-[#111] hover:bg-[#e5e5e5]'
                }`}
            >
              {productoEnCarrito ? 'Modificar' : 'Agregar'}
            </button>
          )}
          <button
            onClick={copiarEnlace}
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#f5f5f5] text-[#111] hover:bg-[#e5e5e5] transition-all"
          >
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CardProduct;
